import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "cart-delivery-locations"
};
const _hoisted_2 = {
    key: 0,
    class: "cart-delivery-locations__single-address"
};
const _hoisted_3 = {
    key: 1,
    class: "row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "card__body" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = {
    key: 0,
    class: "col"
};
const _hoisted_8 = { class: "card__body text-muted" };
import { onMounted, ref, computed } from 'vue';
import cartRepository from "../services/CartRepository";
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import AppAddress from "./AppAddress.vue";
import CartDeliveryLocationForm from "./CartDeliveryLocationForm.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CartDeliveryLocations',
    props: {
        order: {},
        createFunction: { type: Function },
        display: {}
    },
    emits: [
        'select-location'
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const deliveryLocations = ref(null);
        const expandedView = ref(false);
        const showCreateDeliveryLocationForm = ref(false);
        const _display = computed(() => props.display ?? 'show_options');
        onMounted(loadDeliveryLocations);
        function selectLocation(location) {
            if (_display.value === 'hide') {
                return; // no need to load
            }
            if (location.selected) {
                return; // already selected
            }
            if (deliveryLocations.value === null) {
                return;
            }
            const current = deliveryLocations.value.find(loc => loc.selected);
            current && (current.selected = false);
            location.selected = true;
            emit('select-location', location);
        }
        function loadDeliveryLocations() {
            cartRepository
                .listDeliveryLocations(props.order.id, props.order.channel)
                .then(locations => {
                // only keep the selected location
                if (_display.value === 'show_selected') {
                    locations = locations.filter(loc => loc.selected);
                }
                deliveryLocations.value = locations;
            });
        }
        return (_ctx, _cache) => {
            return (deliveryLocations.value && _display.value !== 'hide')
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (deliveryLocations.value.length === 1 && !expandedView.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createVNode(AppAddress, {
                                address: deliveryLocations.value[0].address,
                                variantOrDefault: "inline",
                                class: "text-muted"
                            }, null, 8, ["address"]),
                            _cache[3] || (_cache[3] = _createTextVNode()),
                            (_ctx.$isGranted('PORTAL_DELIVERY_LOCATIONS_MANAGE', 'CUSTOMERS_MANAGE'))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (expandedView.value = true), ["prevent"])),
                                    class: "cart-delivery-locations__toggle-expanded-view",
                                    href: ""
                                }, [
                                    _createVNode(Icon, { name: "edit" })
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deliveryLocations.value, (location) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: location.id,
                                    class: "col"
                                }, [
                                    _createElementVNode("div", {
                                        onClick: ($event) => (selectLocation(location)),
                                        class: _normalizeClass(["card card--bordered card--link mb-3", { 'card--selected': location.selected }])
                                    }, [
                                        _createElementVNode("div", _hoisted_5, [
                                            (location.title)
                                                ? (_openBlock(), _createElementBlock("h5", _hoisted_6, _toDisplayString(location.title), 1))
                                                : _createCommentVNode("", true),
                                            _cache[4] || (_cache[4] = _createTextVNode()),
                                            _createVNode(AppAddress, {
                                                address: location.address
                                            }, null, 8, ["address"])
                                        ])
                                    ], 10, _hoisted_4)
                                ]));
                            }), 128)),
                            _cache[8] || (_cache[8] = _createTextVNode()),
                            (__props.createFunction)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    (_ctx.$isGranted('PORTAL_DELIVERY_LOCATIONS_MANAGE', 'CUSTOMERS_MANAGE'))
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (showCreateDeliveryLocationForm.value = true), ["prevent"])),
                                            class: "card card--link card--placeholder mb-3"
                                        }, [
                                            _createElementVNode("div", _hoisted_8, [
                                                _createVNode(Icon, {
                                                    name: "plus-circle",
                                                    "icon-style": "light"
                                                }),
                                                _cache[5] || (_cache[5] = _createTextVNode()),
                                                _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('delivery.new_delivery_location')), 1)
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    _cache[7] || (_cache[7] = _createTextVNode()),
                                    (showCreateDeliveryLocationForm.value)
                                        ? (_openBlock(), _createBlock(CartDeliveryLocationForm, {
                                            key: 1,
                                            onClose: _cache[2] || (_cache[2] = ($event) => (showCreateDeliveryLocationForm.value = false)),
                                            onSuccess: loadDeliveryLocations,
                                            "create-function": __props.createFunction
                                        }, null, 8, ["create-function"]))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                ]))
                : _createCommentVNode("", true);
        };
    }
});
